import { useTranslation } from 'react-i18next';

import SexFilter from './Filters/SexFilter';
import AlertsFilter from './Filters/AlertsFilter';
import RiskFilter from './Filters/RiskFilter';
import AgeFilter from './Filters/AgeFilter';
import EngagementFilter from './Filters/EngagementFilter';
import CarePlanFilter from './Filters/CarePlanFilter';
import ConditionFilter from './Filters/ConditionFilter';
import FiltersSidebar from 'components/FiltersSidebar';
import ActivityFilter from './Filters/ActivityFilter';
import PatientGroupFilter from './Filters/PatientGroupFilter';
import CareTeamFilter from './Filters/CareTeamFilter';

export default function PatientsFilter(props) {
  const { filters, setFilters, activeFilterTypes = {} } = props;
  const { t } = useTranslation();

  return (
    <FiltersSidebar {...props}>
      <SexFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.gender}
      />
      <AgeFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.age}
      />
      <ActivityFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.activity}
      />
      <RiskFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.risk}
      />
      <AlertsFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.alerts}
      />
      {/* <EngagementFilter setFilters={setFilters} filters={filters} /> */}
      <ConditionFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.condition}
      />
      <CareTeamFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.careTeam}
      />
      <CarePlanFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.carePlan}
      />
      <PatientGroupFilter 
        setFilters={setFilters} 
        filters={filters} 
        defaultExpanded={activeFilterTypes.patientGroup}
      />
    </FiltersSidebar>
  );
}
